import { Button, Skeleton, Text, HStack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';

import { BlockedResource } from '../../../../constants';
import { ItemTag } from '../ItemTag';

interface cardItemDesktopProps {
  blockedResource: BlockedResource;
  onRemoveBlock: (id: number) => void;
  isLoading: boolean;
}
export const CardItemDesktop = ({
  blockedResource,
  onRemoveBlock,
  isLoading,
}: cardItemDesktopProps) => {
  if (isLoading) {
    return (
      <Box
        borderBottomLeftRadius={BoxBorder.thick}
        borderTopLeftRadius={BoxBorder.thick}
        borderTopRightRadius={BoxBorder.heavy}
        borderBottomRightRadius={BoxBorder.heavy}
        backgroundColor={Color.background}
        px={Spacing['stack.xxs']}
        py={Spacing['stack.xxxs']}>
        <HStack alignItems="center" justifyContent="space-between" space={Spacing['stack.xxs']}>
          {Array.from({ length: 3 }).map((field, index) => (
            <VStack justifyContent="center" space={Spacing['stack.quarck']} key={index}>
              <Skeleton
                height="15px"
                width="30px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="15px"
                width="60px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
          ))}

          <Skeleton
            height="15px"
            width="60px"
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </Box>
    );
  }

  return (
    <Box
      borderBottomLeftRadius={BoxBorder.thick}
      borderTopLeftRadius={BoxBorder.thick}
      borderTopRightRadius={BoxBorder.heavy}
      borderBottomRightRadius={BoxBorder.heavy}
      backgroundColor={Color.background}
      px={Spacing['stack.xxs']}
      py={Spacing['stack.xxxs']}>
      <HStack alignItems="center" justifyContent="space-between" space={Spacing['stack.xxs']}>
        {blockedResource.item.map((field, index) => (
          <VStack justifyContent="center" space={Spacing['stack.quarck']} key={index}>
            <Text
              fontSize={Typography['fontsize.md']}
              variant="regular"
              color="brand.primary.darkest">
              {field.key}
            </Text>
            {Array.isArray(field.value) ? (
              <ItemTag data={field.value} />
            ) : (
              <Text
                fontSize={Typography['fontsize.md']}
                variant="regular"
                color="brand.primary.darkest">
                {field.value}
              </Text>
            )}
          </VStack>
        ))}

        <Button
          variant="textLink"
          _text={{
            color: 'brand.tertiary.principal',
            fontWeight: 'semibold',
          }}
          isDisabled={!blockedResource.canDelete}
          onPress={() => onRemoveBlock(blockedResource.id)}>
          REMOVER BLOQUEIO
        </Button>
      </HStack>
    </Box>
  );
};
